import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  title: {
    textAlign: 'center',
    marginBottom: '16px',
    marginTop: 0,
    fontSize: '21px',
  },
  headline: {
    marginBottom: '15px',
    marginTop: 0,
    textAlign: 'center',
    color: '#fd9e67',
    display: 'block',
    fontSize: '36px',
  },

  postIt: {
    boxShadow: '5px 6px 0 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff2dd',
    fontSize: '13px',
    minHeight: '185px',
    padding: '15px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  },
  postItInput: {
    gap: '1rem',
  },
  message: {
    textAlign: 'center',
    fontSize: '13px',
  },
});
